<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/customercareOrders/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Process COD</li>
    </ol>
  </nav>
  <div style="width:300px;">

    <ng-select id="carrier" [(ngModel)]="carriers"
               [ngModelOptions]="{standalone: true}" required
               [items]="carriersList"
               bindLabel="label"
               bindValue="config"
               placeholder="List of Carriers"

               style="color:blue;">
    </ng-select>
  </div>

  <div class="row" style="margin-left:20px; margin-top:10px; padding:10px;">
    <div class="col">
      <label class="import_products add_file">
        <input (change)="loadorder($event)" [(ngModel)]="productImage" [ngModelOptions]="{standalone: true}"
               accept="application/csv+json"
               class="shift-import-input" name="file" type="file"/>
        <span *ngIf="!productImage || productImage == ''"> <img alt="productImage"
                                                                src="/./assets/images/Group_1645.svg"
                                                                style="margin-right: 10px;">Add file</span>
        <span *ngIf="productImage"><img (click)="removeFile()"
                                        alt="productImage"
                                        src="/./assets/images/xx.png"
                                        style="margin-right: 10px;width:20px;">{{getFileName(productImage)}}</span>
      </label>
      <div [hidden]="!statusText2" class="invalid-feedback d-block mb-2" id="statusText2">
        {{statusText2}}
      </div>
      <button (click)="submitImportOrder()" *ngIf="productImage"
              [attr.data-dismiss]="uploadDismissModal"
              [attr.data-target]="uploadPopup"
              class="btn btn-outline-primary" data-toggle="modal" type="button">
        Submit
      </button>
    </div>
  </div>
</section>




